import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TicketRoutingModule } from './ticket-routing.module';
import { TicketDetailsComponent } from './ticket-details/ticket-details.component';
import { CreateTicketComponent } from './create-ticket/create-ticket.component';
import { MyTicketComponent } from './my-ticket/my-ticket.component';
import { AdminModule } from '../admin/admin.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { NgxEditorModule } from 'ngx-editor';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AlertModule, BsDatepickerModule } from 'ngx-bootstrap';
import { SuperAdminModule } from '../superadmin/superadmin.module';
import { TicketComponent } from './ticket/ticket.component';

@NgModule({
  declarations: [CreateTicketComponent,MyTicketComponent,TicketDetailsComponent, TicketComponent],
  imports: [
    CommonModule,
    TicketRoutingModule,
    AdminModule,
    SuperAdminModule,
    NgbModule,
    FormsModule,
    AlertModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgxEditorModule,
   
  ]
})

export class TicketModule { }
